export default __webpack_public_path__ + "static/media/rakhi13.9c773cf9.jpeg";